<div class="container contentBox position-relative px-2">
  <div class="row stickyRow">
    <div class="col-12">
      <h4 class="gilroy-b">Book 1 On 1 eMeeting</h4>
    </div>
    <div class="col-12 d-flex">
      <h6 class="text-center text-muted">
        {{ currentUserTimezone + " Standard Time" }}
      </h6>
    </div>
    <div class="col-12 d-flex">
      <h6 class="text-center text-muted">Meeting Duration</h6>
    </div>
    @for (pakagesData of sharedCreatorPackages; track pakagesData) {
    <div class="col-auto mb-3">
      <input type="radio" [disabled]="isSlotdivLoader" class="btn-check" id="duration-btn" name="duration-btn" />
      <label class="border-0 btn light-bg-col btn-sm gilroy-sb rounded-3 px-2 {{
            packageId == pakagesData.id ? 'activeClass' : ''
          }}" for="duration-btn" (click)="selectMentorPackages(pakagesData)">
        <span>{{ pakagesData.packageName }}</span>
        <b class="pe-1 ps-1">-</b>
        <span>{{ pakagesData.timeSpan.minutes }} min</span>
      </label>
    </div>
    }
    <div class="col-12 pt-2">
      <h6 class="text-muted mb-0 mt-3">Time Slots</h6>
      @if (isSlotdivLoader) {
      <div class="text-center">
        <div class="my-5">
          <app-mini-loading></app-mini-loading>
        </div>
      </div>
      }
      @if (isSlotdivtxt) {
      <p class="gilroy fw-light text-center fw-bold text-muted mt-5">
        No slots are available!
      </p>
      <div class="my-3 text-center">
        <button class="btnPrimary" (click)="userDetails ? informMe() : showModal()">
          Inform Me
        </button>
      </div>
      }
    </div>
  </div>
  <div class="row position-relative">
    @for (daysdata of Datafilter; track daysdata) {
    <div class="col-12 py-2">
      <div class="my-1">
        <h4 class="fs-6 d-inline-block">
          {{ daysdata.convertedTime }}
        </h4>
      </div>

      <div class="row g-3 row-gap-1" [ngClass]="{
            'row-cols-2': (resize.windowSize$ | async)?.width < 520,
            'row-cols-3': ((resize.windowSize$ | async)?.width > 520 && (resize.windowSize$ | async)?.width < 1024) || (resize.windowSize$ | async)?.width > 1024,
            'row-cols-4': (resize.windowSize$ | async)?.width > 768 && (resize.windowSize$ | async)?.width < 1024 || (resize.windowSize$ | async)?.width > 1324,
            }">
        @for (timedata of daysdata.match; track timedata) {
        <div class="col">
          <input type="radio" class="btn-check" [disabled]="!timedata.availablity || timedata.conflict"
            [readOnly]="!timedata.availablity || timedata.conflict" />
          <label class="w-100 btn datentime fs-12 gilroy-sb light-bg-col rounded-3 border-0 {{
                  selectedSechduleId == timedata.id ? 'activeClass' : ''
                }}" [ngClass]="{
                  conflict: !timedata.availablity || timedata.conflict
                }" (click)="selectSechdule(timedata)">
            {{ timedata.fromTiming }} - {{ timedata.toTiming }}</label>
        </div>
        }
      </div>
    </div>
    }
  </div>
  @if (!isSlotdivLoader && !isSlotdivtxt) {
  <div class="fixed-bottom-div dCenter gap-3">
    <button class="btnPrimary gilroy-b rounded-3 w-50" [disabled]="!proceedToPay" (click)="
          filterPackage?.qty > 0 || freeSlotsEnabled
            ? redirectPackageBooking()
            : RedirectRequest('forMe')
        ">
      @if (isLoadingBtn) {
      <app-mini-loading></app-mini-loading>
      } @else {
      @if (filterPackage?.qty > 0 || freeSlotsEnabled) {
      Book Now
      } @else {
      Proceed To Pay {{ sessionPrice}} {{ iscountryPK ? 'Rs ' : 'USD ' }}
      }
      }
    </button>
    <button class="btnPrimary gilroy-b rounded-3 w-50" [disabled]="!proceedToPay" (click)="RedirectRequest('gift')">
      @if (isLoadingBtn) {
      <app-mini-loading></app-mini-loading>
      } @else {
      @if(freeSlotsEnabled){
      Gift a session
      } @else {
      Gift a session {{ sessionPrice }} {{ iscountryPK ? 'Rs ' : 'USD ' }}
      }
      }
    </button>
  </div>
  }
</div>